import { languageMap } from ".."

languageMap.lolcode = {
	comments: {
		line: "BTW",
		block: ["OBTW", "TLDR"],
	},
}
